import { UserUIModel } from '../models/user.model';

export const systemBotEmail = 'git-bot@y42.com';

export const isSystemUser = (user: UserUIModel) => user.email === systemBotEmail;
